// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__33tiq","spinner":"preloader_spinner__J-ioH","spin":"preloader_spin__Iq7CW"};